import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@material-ui/core';
import Logo from './Logo';

const MainNavbar = (props) => (
  <AppBar
    elevation={0}
    {...props}
  >
    <Toolbar sx={{ height: 64 }}>
      <RouterLink to="/">
      <Logo />
        {/* <Typography variant="h2" style={{ color: '#ffd504' }}>
           LOGO
        </Typography> */}
      </RouterLink>
    </Toolbar>
  </AppBar>
);

export default MainNavbar;
